// removed by extract-text-webpack-plugin
module.exports = {"btn":"_3Df3D-ZC76qbz67MQ_6tsN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WechatPayment/WechatPayment.scss
 ** module id = 1101
 ** module chunks = 0
 **/